var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('PageHeader',[_vm._v(" "+_vm._s(_vm.$t('tipSettlements'))+" ")]),_c('div',{staticClass:"d-flex flex-column gap-4"},[_c('Stats',{ref:"Stats"}),_c('Payouts',{ref:"Payouts"}),_c('Invoices',{ref:"Invoices"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }